export function removeUndefinedProperties(object: Record<string, string | undefined>) {
    let copy = { ...object };

    Object.keys(copy).forEach((key) => copy[key] === undefined && delete copy[key]);

    return copy as Record<string, string>;
}

export function isUrlValid(url: string) {
    try {
        new URL(url);
    } catch (_) {
        return false;
    }
    return true;
}
